<h3 class="head-children-device-manager">{{getDeviceType(type)|translate}}
    <button type="button" class="btn modal-tool-add"
            (click)="openModal(content)" placement="left"
            [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate"
            *ngIf="getListChannelAvailableByDeviceType(type).length > 0">
        <fa-icon [icon]="faPlus"></fa-icon>
        {{'ADD'|translate}} {{deviceTypeName|translate}}
    </button>
    <button type="button" class="btn modal-tool-add add-unavailable"
            (click)="errorMessage()" *ngIf="getListChannelAvailableByDeviceType(type).length === 0">
        {{'NO_CHANNEL_AVAILABLE' | translate}}
    </button>
</h3>

<app-progressbar *ngIf="showSpinner===true"></app-progressbar>
<mat-chip-list>
    <mat-chip *ngFor="let children of getListByDeviceType(type)" matBadgeColor="accent" [matBadge]="children.channel"
              matBadgePosition="before"
              style="overflow: initial" [selectable]="selectable"
              [removable]="removable" matTooltipPosition="above" [matTooltip]="'Channel : ' + children.channel ">
        {{children.uid}}

        <mat-icon matChipRemove *ngIf="removable" (click)="remove(children.id) " style="color:red"
                  matTooltipPosition="right" [matTooltip]="'DELETE_ICON_TOOLTIP'|translate">cancel
        </mat-icon>
    </mat-chip>
</mat-chip-list>
